var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 730.759,
    height: 800,
    viewBox: "0 0 730.759 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-268.784 -139.358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.427,781.24a1.384,1.384,0,0,0,1.388,1.388H827.259a1.388,1.388,0,0,0,0-2.776H531.815a1.384,1.384,0,0,0-1.388,1.388Z",
    transform: "translate(170.897 131.778)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.784 139.358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5,0H356.861a68.5,68.5,0,0,1,68.5,68.5V706.546a68.5,68.5,0,0,1-68.5,68.5H68.5A68.5,68.5,0,0,1,0,706.546V68.5A68.5,68.5,0,0,1,68.5,0Z",
    transform: "translate(7.176)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.914,192.725V814.512a69.535,69.535,0,0,1-69.454,69.454h-272.1A69.535,69.535,0,0,1,424.9,814.512V192.725a69.535,69.535,0,0,1,69.454-69.454H529.94v12.291a20.982,20.982,0,0,0,20.98,20.981c46.067,13.915,100.14,11.743,158.977,0a20.982,20.982,0,0,0,20.981-20.98V123.27H766.46a69.535,69.535,0,0,1,69.454,69.454Z",
    transform: "translate(-410.55 -116.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.122,243.145a5.225,5.225,0,0,1-5.219-5.219V227.487a5.219,5.219,0,1,1,10.438,0v10.438a5.225,5.225,0,0,1-5.219,5.219Z",
    transform: "translate(-413.903 -85.917)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.122,288.44a5.225,5.225,0,0,1-5.219-5.219V254.487a5.219,5.219,0,0,1,10.438,0v28.734A5.225,5.225,0,0,1,419.122,288.44Z",
    transform: "translate(-413.903 -77.688)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.122,321.418A5.225,5.225,0,0,1,413.9,316.2V287.466a5.219,5.219,0,0,1,10.438,0V316.2A5.225,5.225,0,0,1,419.122,321.418Z",
    transform: "translate(-413.903 -67.636)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.243,149.889h-35.23a6.524,6.524,0,1,1,0-13.048h35.23a6.524,6.524,0,0,1,0,13.048Z",
    transform: "translate(-399.399 -111.955)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.252,192.508V524.631c0,38.3-411.01,38.3-411.01,0V192.508A69.535,69.535,0,0,1,493.7,123.054h35.582v12.291a20.982,20.982,0,0,0,20.98,20.981c44.11,13.853,98.565,11.573,158.977,0a20.982,20.982,0,0,0,20.981-20.98V123.054H765.8a69.535,69.535,0,0,1,69.454,69.454Z",
    transform: "translate(-410.752 -116.157)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.695,425.842v6.524c0,38.3,411.011,38.3,411.011,0v-6.524C835.705,464.138,424.695,464.138,424.695,425.842Z",
    transform: "translate(-410.614 -23.868)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.643,784.751c-.223-.365-5.483-9.147-7.306-27.384-1.673-16.732-.6-44.934,14.029-84.275,27.709-74.528-6.386-134.661-6.734-135.26l1.682-.976c.088.152,8.886,15.483,14.083,39.9a174.054,174.054,0,0,1-7.209,97.017c-27.661,74.4-7.1,109.621-6.886,109.968Z",
    transform: "translate(-261.503 -17.099)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.637,
    cy: 12.637,
    rx: 12.637,
    ry: 12.637,
    transform: "translate(191.67 491.083)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.637,
    cy: 12.637,
    rx: 12.637,
    ry: 12.637,
    transform: "translate(231.523 537.742)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.637,
    cy: 12.637,
    rx: 12.637,
    ry: 12.637,
    transform: "translate(204.306 568.847)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.637,
    cy: 12.637,
    rx: 12.637,
    ry: 12.637,
    transform: "translate(237.355 595.092)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.637,
    cy: 12.637,
    rx: 12.637,
    ry: 12.637,
    transform: "translate(194.587 635.918)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.666,790.792s-12.637-31.105,25.273-54.435Z",
    transform: "translate(-261.891 -22.676)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.29,790.834s-5.751-33.078-50.263-32.795Z",
    transform: "translate(-260.057 -23.282)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.384,
    cy: 104.384,
    r: 104.384,
    transform: "translate(114.611 125.915)",
    fill: "#6c63ff",
    opacity: 0.097
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.51,
    cy: 73.51,
    r: 73.51,
    transform: "translate(145.486 156.789)",
    fill: "#6c63ff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.516,
    cy: 48.516,
    r: 48.516,
    transform: "translate(170.478 181.783)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.862,419.4a8.821,8.821,0,1,0-14.394,6.836l-3.249,22.741h17.642l-3.249-22.741A8.8,8.8,0,0,0,427.862,419.4Z",
    transform: "translate(-200.046 -199.565)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(721.012 310.252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782.753,139.359s-21.042-18.865-49.339,16.688S660.856,209.014,650.7,222.8c0,0,42.084-17.414,56.6-24.67s13.786-5.8,13.786-5.8S701.488,206.112,697.86,219.9s-.726,25.4-7.256,39.181,124.8,9.433,124.8,9.433,13.06-22.493,9.432-45.711S823.385,142.261,782.753,139.359Z",
    transform: "translate(-572.482 -134.358)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.758,202.56s4.575,32.029-15.034,39.219S719.3,258.774,719.3,258.774l29.414,14.38,31.375-9.8,10.458-15.688s-16.995-3.922-12.419-15.687,5.883-15.687,5.883-15.687Z",
    transform: "translate(-576.286 -141.628)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.165,299.551s-4.576,60.135-3.268,62.75,0,93.471,0,93.471,1.256,32.66-5.964,42.786c-.627.889-4.613,2.177-5.8,2.441-11.766,2.615,0-48.5,0-48.5l-11.766-75.823,1.307-75.169Z",
    transform: "translate(-581.335 -147.108)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.423,491.454s-21.57,81.706-20.917,121.578,9.151,95.432,9.151,95.432,1.307,24.185-.654,26.8,9.8,13.727,9.8,13.727l12.419-7.19,4.576-5.229V732s-7.19-22.224-1.307-39.872,9.151-62.1,3.268-75.823L756.29,496.029Z",
    transform: "translate(-574.053 -157.952)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.727,752.9s-7.844-9.8-13.073-6.536-13.727,25.492-13.727,25.492-29.414,28.107-8.5,29.414,30.068-5.883,32.682-11.112,26.8-18.956,26.8-18.956-2.615-24.839-6.536-25.492-9.8,9.8-9.8,9.8Z",
    transform: "translate(-572.664 -172.317)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.642,495.85V576.9a250.6,250.6,0,0,0,1.961,29.414c1.961,14.38-11.112,121.578-11.112,121.578L767.8,746.85l16.341-1.307L786.1,729.2l23.531-71.9s7.844-43.794,3.922-60.135S828.2,476.711,828.2,476.711Z",
    transform: "translate(-579.025 -157.119)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.251,757.729l4.841-1.052s3.656-8.1,8.232-6.138a49.345,49.345,0,0,1,9.1,5.452l2.014,3.7s4.576,9.8,10.458,16.341,12.419,20.917,2.615,22.224-22.878,1.961-26.8-1.307-1.307-8.5-5.229-9.8-7.19-5.229-6.536-6.536S762.251,757.729,762.251,757.729Z",
    transform: "translate(-578.707 -172.574)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.05,
    cy: 29.05,
    r: 29.05,
    transform: "translate(167.566 28.761)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718,249.489l8.634-3.014s-3.4,5.629,14.9,8.9,37.256,4.425,45.754-6.285c0,0,3.269-1.559,7.845,3.016s7.19,3.268,7.19,3.268l-3.268,16.995-6.536,31.375-8.5,23.531-24.185-5.229-26.146-18.956-9.8-25.492V254.065Z",
    transform: "translate(-576.285 -144.109)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.783,258.786l6.536-4.576s22.224,3.922,23.531,14.38l-16.995,32.682a37.208,37.208,0,0,1-.654,28.107c-6.536,15.034-5.883,18.3-5.883,18.3l-4.575,19.609-83.013,6.536s-3.268-7.844-4.575-9.151-1.307-5.883,0-5.883,0-1.961-1.307-3.922-1.961-2.615,0-5.229S705.58,323.5,705.58,323.5V298l-22.224-29.414s7.844-11.766,11.766-13.073,22.578-6.463,22.578-6.463l4.221,6.216L727.8,302.58l8.5,28.76,35.778-6.079,13.9-23.335,9.151-27.453Z",
    transform: "translate(-574.328 -144.255)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.863,265.6l5.229,3.922s4.576,36.6,3.268,39.219-24.185,5.229-24.839,3.922S827.863,265.6,827.863,265.6Z",
    transform: "translate(-581.569 -145.19)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.319,246.049l6.537,43.141s-5.883,64.057-4.576,77.13l1.307,3.922s-2.615-1.307-3.268,1.307,0,11.112,0,11.112-3.922,3.922-5.229,25.492-19.751,83.013-13.868,84.974,49.379,20.553,68.334,18.592,71.812-12.709,71.158-18.592S810.058,373.51,810.058,373.51s-5.883-9.8-5.883-11.112,7.844-6.536,5.883-11.766S797.639,290.5,797.639,290.5l7.19-39.219-9.8-2.615-7.19,37.911s-28.107,13.727-57.521,1.307l-6.536-44.448Z",
    transform: "translate(-574.876 -143.937)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.864,172.752s48.37,33.336,61.443,18.3-22.878-28.107-22.878-28.107l-30.068-3.268Z",
    transform: "translate(-577.973 -135.789)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.607,541.057a22.4,22.4,0,1,0-7.026-8.721l-58.6,48.789-7.8-9.26-3.505,2.344-3.9-4.63,3.205-2.7-3.9-4.63-4.986,4.2,2.4,2.849-5.342,4.5-2.4-2.849-7.835,6.6,3.6,4.274,2.849-2.4,3.9,4.63-3.562,3,7.2,8.547-8.548,7.2,8.7,10.328Zm14.631-32.728a14.819,14.819,0,1,1-16.027,13.5,14.819,14.819,0,0,1,16.027-13.5Z",
    transform: "translate(-547.915 -158.474)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.5,307.864s4.576,60.135,3.268,62.75,0,93.471,0,93.471-9.151,49.023,2.615,51.638,9.151-54.906,9.151-54.906L705.3,384.994l-1.307-75.169Z",
    transform: "translate(-574.046 -147.578)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.128,267.682l-5.229,1.961s-9.8,41.18-7.19,41.18,33.99,3.922,33.99,2.615-5.883-33.336-5.883-33.336Z",
    transform: "translate(-573.871 -145.307)",
    fill: "#6c63ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.363965a2d453990963a763a7e7dfdb04.svg";
export { ForwardRef as ReactComponent };